import axios from '../utils/axios';

export interface ScanRegulatoryReportRow {
  retailId: string;
  labelIndex: number;
  printRunId: number;
  jobName?: string | null;
  packageLabel?: string | null;
  packageType?: string | null;
  productionBatchNumber?: string | null;
  productName?: string | null;
  productCategory?: string | null;
  strain?: string | null;
  organizationName?: string | null;
  facilityName?: string | null;
  license?: string | null;
  marketName?: string | null;
  packagedDate?: string | null;
  printPackagedDate?: string | null;
  labelsLastGeneratedDateTime?: string | null;
  printCreatedAt?: string | null;
  printedDate?: string | null;
}

export async function getScanRegulatoryReport(qr: string, signal: AbortSignal): Promise<ScanRegulatoryReportRow[]> {
  const response = await axios.get<ScanRegulatoryReportRow[]>('/reports/scan-regulatory', {
    params: { qr },
    signal,
  });
  return Array.isArray(response?.data) ? response.data : [];
}
